// extracted by mini-css-extract-plugin
export default {"orders":"orders_orders__anFgs","ordersContainer":"orders_ordersContainer__H2676","ordersList":"orders_ordersList__i2li5","description":"orders_description__y-3Ut"};